import { WithContext, Person } from "schema-dts";
import { apiHostAndPath } from "utils/api";
import {
  getOrchidProFullName,
  getOrchidProTypeStringFromNewArr,
} from "utils/formatter/orchidPro";
import getCanonicalLink from "utils/getCanonicalLink";

const getOrchidProStructuredData = (
  orchidPro?: OrchidPro,
): WithContext<Person> | null => {
  if (!orchidPro) {
    return null;
  }

  const structuredData: WithContext<Person> = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: getOrchidProFullName(orchidPro),
    givenName: orchidPro.preferred_first_name || orchidPro.first_name,
    familyName: orchidPro.last_name,
    image: apiHostAndPath(
      `/api/users/orchid_pro/profile_image/${orchidPro.cognito_sub}`,
    ),
    description: orchidPro.biography,
    affiliation: orchidPro.organization,
    alumniOf: orchidPro.graduate?.map((graduate) => graduate.conferring_entity),
    address: {
      "@type": "PostalAddress",
      addressLocality: orchidPro.office_city,
      addressRegion: orchidPro.office_state,
      postalCode: orchidPro.office_zipcode,
      streetAddress: `${orchidPro.office_address_line1} ${orchidPro.office_address_line2}`,
    },
    jobTitle: getOrchidProTypeStringFromNewArr(orchidPro),
    honorificSuffix: orchidPro.graduate
      ?.map((graduate) => graduate.degree)
      .filter((degree) => degree?.length && degree.length > 0)
      .join(", "),
    knowsLanguage: orchidPro.languages,
    url: getCanonicalLink(
      `/professional-search/${orchidPro.custom_url ?? orchidPro.cognito_sub}`,
    ),
  };

  return structuredData;
};

export default getOrchidProStructuredData;
